import { IPricing, IStateOffers } from "@/apps/merchant3/models/IStateOffers";

const getters = {
  getPricing: (state: IStateOffers): IPricing => state.pricing,
  getDownPayment: (state: IStateOffers): string => {
    if (state.selectedDeviceModelObject?.minFinanceAmount) {
      return `${state.selectedDeviceModelObject?.minFinanceAmount}`;
    }
    return "0";
  },
  getOfferErrorMESSAGE: (state: IStateOffers): string =>
    state.offerErrorMessage,

  getLoading: (state: IStateOffers): boolean => state.loading,
};

export default getters;
